import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ContactSearchQuery,
  ContactSearchQueryVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const contactSearch = graphql(`
  query contactSearch($input: ContactSearchInput!) {
    contactSearch(input: $input) {
      nodes {
        id
        source
        redeemId
        tier
        firstName
        lastName
        fullName
        jobTitle
        seniorityTier
        account {
          id
          name
        }
        buyer {
          id
          name
          isStotlesVerified
          logoUrl
          categoryAssignments {
            categoryId
            source
          }
        }
        oscarOrgName
        hasEmail
        hasMobilePhoneNumbers
        hasDirectPhoneNumbers
        hasLinkedinUrl
        isRevealed
        redeemedContactRowId
        jobFunction
        email
        phoneNumbers
        mobilePhoneNumbers
        directPhoneNumbers
        linkedinUrl
      }
      pageInfo {
        endCursor
        hasNextPage
      }
      totalResults
    }
  }
`);

export type ContactSearchConnection = ContactSearchQuery["contactSearch"];
export type ContactSearchResult = ContactSearchConnection["nodes"][number];

/**
 * Cursor-paginated Cognism contact search. Each cursor page is cached under its
 * own query key, so paging back to a previous cursor is served from cache.
 */
export function useContactSearch(
  input: ContactSearchQueryVariables["input"],
  options?: UseQueryOptions<ContactSearchQuery, unknown, ContactSearchQuery, QueryKey>,
) {
  return useGraphQlQuery(["contactSearch", input], contactSearch, [{ input }], { ...options });
}
